import * as React from "react";
import {Box} from "@mui/material"


const DATASTUDIO_LINK = 'https://lookerstudio.google.com/embed/u/0/reporting/48fdfa6c-6df0-44fd-a899-016882f4c410/page/p_wijmxiyc8c'

export default function CatalogueLegacyIframePage() {

    return <Box style={{ width: '100%', height: '100%', pr: 0 }}>
        <iframe
            src={DATASTUDIO_LINK}
            allowFullScreen
            sandbox="allow-scripts allow-popups allow-same-origin"
            style={{
                width: '100%',
                height: '84vh',
                border: 'none',
            }}
        />
    </Box>
}